import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";


const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-5 pb-3">
      <div
      data-elementor-type="wp-post"
      data-elementor-id={16}
      className="elementor elementor-16"
    >
      <section
        className="elementor-section elementor-top-section elementor-element elementor-element-ded5904 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="ded5904"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div className="elementor-container elementor-column-gap-no">
          <div
            className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-b21455b"
            data-id="b21455b"
            data-element_type="column"
          >
            <div className="elementor-widget-wrap elementor-element-populated">
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-bd21854 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="bd21854"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-f795c7e"
                    data-id="f795c7e"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-b4365d9 elementor-widget elementor-widget-image"
                        data-id="b4365d9"
                        data-element_type="widget"
                        data-widget_type="image.default"
                      >
                        <div className="elementor-widget-container">
                          <img
                            width={525}
                            height={112}
                            src={`${process.env.PUBLIC_URL}/logo 2.png`}
                            className="attachment-large size-large wp-image-20"
                            alt=""
                            srcSet={`${process.env.PUBLIC_URL}/logo 2.png `}
                            sizes="(max-width: 525px) 100vw, 525px"
                          />{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-82a0878 elementor-widget elementor-widget-text-editor"
                        data-id="82a0878"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          Green Circle Environment Pvt. Ltd. is an Indian-owned company providing engineering services, road and public works construction, real estate development, and project management.{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-0ea0d07 elementor-widget elementor-widget-text-editor"
                        data-id="0ea0d07"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        {/* <div className="elementor-widget-container">
                          The company offers Engineering services ,construction to road, public work agencies, municipalities commercial/Residential real estate develo pers,road construction and project management.{" "}
                        </div> */}
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-86667a8"
                    data-id="86667a8"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-602bc25 elementor-widget elementor-widget-heading"
                        data-id="602bc25"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Links
                          </h2>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-63e41d0 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                        data-id="63e41d0"
                        data-element_type="widget"
                        data-widget_type="icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="elementor-icon-list-items">
                           <li className="elementor-icon-list-item">
  <Link to="/about">
    <span className="elementor-icon-list-text">
      About Us
    </span>
  </Link>
</li>

                            <li className="elementor-icon-list-item">
                              <Link to="/solid-waste-management">
                                <span className="elementor-icon-list-text">
                                  Services
                                </span>
                              </Link>
                            </li>
                            <li className="elementor-icon-list-item">
                              <Link to="/products">
                                <span className="elementor-icon-list-text">
                                  Products
                                </span>
                              </Link>
                            </li>
                            
                            <li className="elementor-icon-list-item">
                              <Link to="/contact-us">
                                <span className="elementor-icon-list-text">
                                  Contact Us
                                </span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-31fd7a3"
                    data-id="31fd7a3"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-61011c3 elementor-widget elementor-widget-heading"
                        data-id="61011c3"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Working Hours
                          </h2>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-c0e05d2 elementor-widget elementor-widget-text-editor"
                        data-id="c0e05d2"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          Our team is available throughout the week to assist you during the hours below.{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-24d9030 elementor-widget elementor-widget-text-editor"
                        data-id="24d9030"
                        data-element_type="widget"
                        data-widget_type="text-editor.default"
                      >
                        <div className="elementor-widget-container">
                          Mon – Fri: 9:00AM – 6:00PM <br />
                          Sat – Sun: 8:00AM – 4:00PM{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="elementor-column elementor-col-25 elementor-inner-column elementor-element elementor-element-0aca8fa"
                    data-id="0aca8fa"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-3982f0b elementor-widget elementor-widget-heading"
                        data-id="3982f0b"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            Get In Touch
                          </h2>{" "}
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-2c56c76 elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                        data-id="2c56c76"
                        data-element_type="widget"
                        data-widget_type="icon-list.default"
                      >
                        <div className="elementor-widget-container">
                          <ul className="elementor-icon-list-items">
                            <li className="elementor-icon-list-item">
                              <a href="#">
                                <span className="elementor-icon-list-icon">
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-fas-map-marker-alt"
                                    viewBox="0 0 384 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z" />
                                  </svg>{" "}
                                </span>
                                <span className="elementor-icon-list-text">
                                  <span className="text-white">
                                    D-2/7,Industrial Estate,rasulgarh-751010
                                  </span>{" "}
                                </span>
                              </a>
                            </li>
                            <li className="elementor-icon-list-item">
                              <a href="#">
                                <span className="elementor-icon-list-icon">
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-far-envelope"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z" />
                                  </svg>{" "}
                                </span>
                                <span className="elementor-icon-list-text">
                                  <span className="text-white">Email :</span>{" "}
                                 gcindia01@gmail.com
greencircleenvironment@gmail.com


                                </span>
                              </a>
                            </li>
                            <li className="elementor-icon-list-item">
                              <a href="#">
                                <span className="elementor-icon-list-icon">
                                  <svg
                                    aria-hidden="true"
                                    className="e-font-icon-svg e-fas-phone-alt"
                                    viewBox="0 0 512 512"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path d="M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z" />
                                  </svg>{" "}
                                </span>
                                <span className="elementor-icon-list-text">
                                  <span className="text-white">Phone :</span>{" "}
                                  +91 9439366515
0674-2549187 / 2548306
                                </span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
              </section>
              <section
                className="elementor-section elementor-inner-section elementor-element elementor-element-a2fd193 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                data-id="a2fd193"
                data-element_type="section"
              >
                <div className="elementor-container elementor-column-gap-no">
                  <div
                    className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-bc75dfc"
                    data-id="bc75dfc"
                    data-element_type="column"
                  >
                    <div className="elementor-widget-wrap elementor-element-populated">
                      <div
                        className="elementor-element elementor-element-3d2b884 elementor-widget elementor-widget-heading"
                        data-id="3d2b884"
                        data-element_type="widget"
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            <a href="#">
                              Copyright 2025 by{" "}
                              <span className="theme-color">Greencircleenvironment</span>{" "}
                              All Right Reserved.   Developed by <span className="theme-color">UPTULASOFT</span>
                            </a>
                          </h2>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </section>
    </div>
    </footer>
  );
};

export default Footer;
